import React, { useState, useEffect, Fragment } from 'react';
import { DropdownToggle, DropdownMenu, Dropdown, DropdownItem } from 'reactstrap';
import { get, includes } from 'lodash';
import { connect } from 'react-redux';
import { MDTApp } from '../../../../../actions/bootAction.js';
import './toolbarProfile.css';
import { IconSet } from '../../../../atoms/mdt-iconset/index.js';
import { sendEventTrackingData } from '../../../../../helpers/commonUtils.js';

const ToolbarProfile = (props) => {
    const appid = MDTApp.getSetting('appid');
    const {
        customerName = '',
        classes,
        isInternalUser,
        t,
        customersListData,
        supportedSuppliers,
        userConfig,
    } = props;
    const supplier = get(customersListData, 'suppliersIds[0]');
    const showNewNotificationPreferences =
        (supplier && includes(supportedSuppliers, supplier)) || false;
    const PREFERENCES_TABS = MDTApp.getSetting('accountPreferencesTabIds');

    const [dropdownOpen, setDropdownOpen] = useState(false);

    useEffect(() => {
        if (dropdownOpen) {
            const eventParamObj = {
                eventCategory: 'globalHeader',
                eventAction: 'profileMenu',
                eventLabel: props.pageName,
                processLabels: false,
            };
            sendEventTrackingData(eventParamObj);
        }
    }, [dropdownOpen, props]);

    const toggle = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const reportToAnalytics = ({
        eventCategory = 'globalHeader',
        eventAction = 'profileSubMenu',
        eventLabel = 'View Profile',
        processLabels = false,
        processActions = true,
    }) => {
        sendEventTrackingData({
            eventCategory,
            eventAction,
            eventLabel,
            processLabels,
            processActions,
        });
    };

    const redirectUserProfile = (hash, preferences) => {
        const url = MDTApp.getSetting('links.portal-edit-profile-v2'); // this is coming from cent-app
        const userPreferences = MDTApp.getSetting('links.userPreferences') || ''; // this is coming from dashboard-app

        reportToAnalytics({
            eventLabel: preferences,
        });

        if (appid === window.MDTSetting.authAppId) {
            // if app is portal
            userPreferences && MDTApp.goto(`${userPreferences}#${hash}`);
        } else MDTApp.goto(`${url}#${hash}`);
    };

    const logout = (e) => {
        e.preventDefault();
        const { isInternalUser } = props;
        const dateTime = new Date().toJSON();
        const userType = isInternalUser === 'True' ? 'Internal' : 'External';
        const eventLabel = `Logout_${userType} : ${dateTime}`;
        const eventParamObj = {
            eventCategory: 'accManagement',
            eventAction: 'Cognito Logout',
            eventLabel,
            processLabels: false,
            processActions: false,
        };
        sendEventTrackingData(eventParamObj);
        MDTApp.logout();
    };

    return (
        <div className={classes}>
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle caret>
                    <span className='body2 p-active display-name px-sm-5'>
                        <IconSet name='User-new' className='user-profile' />
                        <span className='d-none d-sm-block'>{customerName}</span>
                    </span>
                </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem divider />
                    <DropdownItem
                        title={t('myProfile')}
                        onClick={() =>
                            redirectUserProfile(PREFERENCES_TABS.ACCOUNT, 'view Profile')
                        }
                    >
                        <span
                            className='menu-text body2 p-active'
                            data-auid='header-view-profile-link'
                            data-test='viewProfile'
                        >
                            {t('myProfile')}
                        </span>
                    </DropdownItem>
                    {(!userConfig?.configuration?.hideNotificationPreferences ||
                        showNewNotificationPreferences) && (
                        <>
                            <DropdownItem divider />
                            <DropdownItem
                                title={t('myAlerts')}
                                onClick={() =>
                                    redirectUserProfile(PREFERENCES_TABS.NOTIFICATION, 'alerts')
                                }
                            >
                                <span
                                    className='menu-text body2 p-active'
                                    data-auid='header-view-profile-link'
                                    data-test='alerts'
                                >
                                    {t('myAlerts')}
                                </span>
                            </DropdownItem>
                        </>
                    )}
                    {!!showNewNotificationPreferences && (
                        <>
                            <DropdownItem divider />
                            <DropdownItem
                                title={t('manageNotification')}
                                onClick={() =>
                                    redirectUserProfile(
                                        PREFERENCES_TABS.NOTIFICATIONID2,
                                        'Manage Notification'
                                    )
                                }
                            >
                                <span
                                    className='menu-text body2 p-active'
                                    data-auid='header-view-profile-link'
                                    data-test='manageNotification'
                                >
                                    {t('manageNotification')}
                                </span>
                            </DropdownItem>
                        </>
                    )}
                    <DropdownItem divider />
                    <DropdownItem
                        title={t('passwordSecurity')}
                        onClick={() =>
                            redirectUserProfile(PREFERENCES_TABS.ACCOUNT, 'Password & Security')
                        }
                    >
                        <span
                            className='menu-text body2 p-active'
                            data-auid='header-view-profile-link'
                            data-test='passwordSecurity'
                        >
                            {t('passwordSecurity')}
                        </span>
                    </DropdownItem>
                    {/* {
            !userConfig?.configuration?.hideNotificationPreferences && (
              <Fragment>
                <DropdownItem divider />
                <DropdownItem onClick={() => redirectUserProfile(PREFERENCES_TABS.NOTIFICATION, 'Notification Preferences')}>
                  <span
                    className="menu-text body2 p-active"
                    data-auid="header-view-profile-link"
                    data-test="notificationPreferences"
                  >
                    {t('notificationPreferences')}
                  </span>
                </DropdownItem>
              </Fragment>
            )
          } */}
                    {!userConfig?.configuration?.hidePaymentAndInvoicePreferences && (
                        <>
                            <DropdownItem divider />
                            <DropdownItem
                                title={t('paymentPreferences')}
                                onClick={() =>
                                    redirectUserProfile(
                                        PREFERENCES_TABS.CREDITCARD,
                                        'Payment Preferences'
                                    )
                                }
                            >
                                <span
                                    className='menu-text body2 p-active'
                                    data-auid='header-view-profile-link'
                                    data-test='paymentPreferences'
                                >
                                    {t('paymentPreferences')}
                                </span>
                            </DropdownItem>
                        </>
                    )}
                    <DropdownItem divider />
                    <DropdownItem title={t('logout')} onClick={logout}>
                        <span className='menu-text body2 p-active' data-test='logout'>
                            {t('logout')}
                        </span>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        customerName: !!state.meDetails.user ? state.meDetails.user.name || '' : '',
        pageName: state.page,
        isInternalUser: state.meDetails.isInternal || 'false',
        customersListData: get(state, 'meDetails.customer', {}),
        supportedSuppliers: get(state, 'meDetails.supportedSuppliers', []),
        userConfig: get(state, 'formConfig.featureConfiguration.ProfilePreferences', {}),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        sso: (redirectFlag, editProfileUrl) => dispatch(MDTApp.sso(redirectFlag, editProfileUrl)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ToolbarProfile);
